import { render, staticRenderFns } from "./wp-footer.vue?vue&type=template&id=621c03af&lang=pug&"
import script from "./wp-footer.vue?vue&type=script&lang=js&"
export * from "./wp-footer.vue?vue&type=script&lang=js&"
import style0 from "./wp-footer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/rain/projects/themes/achernar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('621c03af')) {
      api.createRecord('621c03af', component.options)
    } else {
      api.reload('621c03af', component.options)
    }
    module.hot.accept("./wp-footer.vue?vue&type=template&id=621c03af&lang=pug&", function () {
      api.rerender('621c03af', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/wp-footer.vue"
export default component.exports